import { AxiosResponse } from "axios";
import config from "../../../../config/config";
import ApiClient from "../../ApiClient";
import { IGraphics, IGraphicsAddRequest, IGraphicsPattern, IGraphicsUpdateRequest } from "./types";
import fileDownload from "js-file-download";

const graphicsApi = new ApiClient("/Graphics", config.api.baseUrl);

/**
 * Returns a list of all graphics.
 * @param token
 */
export const getGraphicsCatalogue = (token: string): Promise<IGraphics[]> => {
    ApiClient.setAuthorizationToken(token);

    return graphicsApi
        .get("/list", {
            clearCacheEntry: true,
        })
        .then((response: AxiosResponse<IGraphics[]>) => {
            return Promise.resolve(response.data);
        });
};

/**
 * Returns a list of all graphics patterns.
 * @param token
 */
export const getGraphicsPatternCatalogue = (token: string): Promise<IGraphicsPattern[]> => {
    ApiClient.setAuthorizationToken(token);

    return graphicsApi
        .get("/patterns", {
            clearCacheEntry: true,
        })
        .then((response: AxiosResponse<IGraphicsPattern[]>) => {
            return Promise.resolve(response.data);
        });
};

/**
 * Create graphics into catalogue and return created entity.
 * @param token
 * @param data
 */
export const addGraphicsCatalogue = (token: string, data: IGraphicsAddRequest): Promise<IGraphics> => {
    ApiClient.setAuthorizationToken(token);

    return graphicsApi.post("/add", data).then((response: AxiosResponse<IGraphics>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Update graphics in catalogue and return updated entity.
 * @param token
 * @param graphicsID
 * @param data
 */
export const updateGraphicsCatalogue = (
    token: string,
    graphicsID: number,
    data: IGraphicsUpdateRequest
): Promise<IGraphics> => {
    ApiClient.setAuthorizationToken(token);

    return graphicsApi.post(`/${graphicsID}/update`, data).then((response: AxiosResponse<IGraphics>) => {
        return Promise.resolve(response.data);
    });
};

/**
 * Deletes graphics from catalogue.
 * @param token
 * @param graphicsID
 */
export const deleteGraphicsCatalogue = (token: string, graphicsID: number): Promise<boolean> => {
    ApiClient.setAuthorizationToken(token);

    return graphicsApi.get(`/${graphicsID}/delete`).then((response: AxiosResponse<boolean>) => {
        return Promise.resolve(response.status === 204);
    });
};

/**
 * Export graphics, file is downloaded
 * @param token
 */
export const exportGraphics = (
    token: string
): Promise<void> => {
    ApiClient.setAuthorizationToken(token);

    return graphicsApi
        .get(`/export`, {
            responseType: "blob"
        })
        .then((response) => {
            // Promise.resolve(response.data)
            fileDownload(response.data, "graphics.xlsx");
            return;
        });
};

/**
 * Import graphics, file is uploaded
 * @param token
 * @param data
 */
export const importGraphics = (
    token: string,
    data: FormData
): Promise<void> => {
    ApiClient.setAuthorizationToken(token);

    return graphicsApi
        .post(`/import`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {
            return Promise.resolve(response.data)
        })
        .catch((response) => {
            return Promise.reject(response.data)
        });
};